import { Injectable, Optional, SkipSelf } from '@angular/core';
import {
  CanActivate, CanActivateChild, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanLoad
} from '@angular/router';

import { AuthService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class NotVerifiedGuard implements CanActivate, CanActivateChild, CanLoad {

  constructor(private router: Router, @Optional() private auth: AuthService) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const url: string = state.url;
    const user = await this.auth.authenticated();
    if (user && user.id) {
      return true;
    }
    this.router.navigate(['/login'], { queryParams: { redirect_to: url } })
    return false
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.canActivate(route, state)
  }

  async canLoad(): Promise<boolean> {
    const user = await this.auth.authenticated()
    if (user && user.id) {
      return true;
    }
    return false
  }

}
